import { DropdownOptionModel } from './dropdown-option-model';

import {
  LDCLPBPPublicApiModelsGovernmentDeclarationsRequest as GovernmentDeclarationsRequest
} from '../../../generated/internalApi/model/models';

import OwnedPropertyTitleTypeEnum = GovernmentDeclarationsRequest.OwnedPropertyTitleTypeEnum;

export const TITLE_TYPE_OPTIONS: DropdownOptionModel<OwnedPropertyTitleTypeEnum>[] = [
  { value: OwnedPropertyTitleTypeEnum.Self, display: 'By yourself' },
  { value: OwnedPropertyTitleTypeEnum.WithSpouse, display: 'Jointly with your spouse' },
  { value: OwnedPropertyTitleTypeEnum.WithOther, display: 'Jointly with another person' }
];
